// import Form from './form'

export default {
  // ...Form,
  RoleFunction: {
    ClinicReadonly: '诊所端 · 只读',
    AdminFull: '管理员 · 可编辑',
    Authority: '依角色权限',
    ClinicReadonlyDesc: '身份限制优先于角色权限，目前仅可查看，不能修改。',
    AdminDesc: '管理员可编辑全部权限。',
    AuthorityDesc: '可操作范围由当前角色授予的权限决定。',
    AdminOnly: '仅管理员可操作',
    ReadonlyOnly: '诊所端查看模式，仅可查看',
  },
}
